import { render, staticRenderFns } from "./clipper-basic.vue?vue&type=template&id=35d168c0&scoped=true"
import script from "./clipper-basic.vue?vue&type=script&lang=js"
export * from "./clipper-basic.vue?vue&type=script&lang=js"
import style0 from "./clipper-basic.vue?vue&type=style&index=0&id=35d168c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d168c0",
  null
  
)

export default component.exports